import ApiService from "../ApiService";

class Client {
  constructor(data) {
    if (!data) {
      data = {};
    }

    this.id = data.id;
    this.fio = data.fio || "";
    this.email = data.email || "";
    this.phone = data.phone || "";
    this.is_client = true;
    this.type = "client";
  }
  getFullName() {
    return this.fio;
  }
  async editProfile(profile) {
    await ApiService.put(`/user/${this.id}/`, profile);
    this.fio = profile.fio;
    this.email = profile.email;
    this.phone = profile.phone;
  }
  async changePassword(current_password, new_password) {
    await ApiService.post(`/user/set-password/`, {
      current_password,
      new_password
    });
  }
}

export default Client;
